import React from 'react';
var getUrlFromIframe = function getUrlFromIframe(code) {
  try {
    var _ref = /\?url=(.*?)&/.exec(code) || '',
      url = _ref[1];
    return url;
  } catch (error) {
    return '';
  }
};
var Soundcloud = function Soundcloud(_ref2) {
  var codigo = _ref2.codigo;
  return React.createElement('iframe', {
    width: '100%',
    height: '166',
    scrolling: 'no',
    frameborder: 'no',
    allow: 'autoplay',
    src: 'https://w.soundcloud.com/player/?url=' + getUrlFromIframe(codigo) + '&color=%23002d72&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false'
  });
};
export default Soundcloud;